import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DivisionInfo } from '../model/division.model';
import { TimeSheetChecklistInfo } from '../model/timesheetChecklist.model';

@Component({
  selector: 'app-timesheet-checklist',
  templateUrl: './timesheet-checklist.component.html',
  styleUrls: ['./timesheet-checklist.component.css']
})
export class TimesheetChecklistComponent implements OnInit {

  baseurl: string;
  _ForK2: string;
  _EmpCode: string;

  //Primary data
  modelOnPromise: Promise<TimeSheetChecklistInfo[]>
  modelList: TimeSheetChecklistInfo[] = [];

  //Search Conditions
  ListDivision: DivisionInfo[] = [];
  isSearchSubmitted: boolean = false;
  txtSchDivision: string = "";
  txtSchMonthYear: string = "";

  //Pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number;
  public itemTotal: any;
  public totalPages: number;
  public pagesize: number = 15;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private location: Location, private activatedRoute: ActivatedRoute) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;

    GlobalService.CheckPagingAccessRights();
  }


  //============================ ngOnInit [Start] ===============================================
  ngOnInit(): void {
    this._EmpCode = localStorage.getItem("EmpCode");

    this.currentPageNumber = 1;
    this.LoadData();
    this.LoadDivision().then((data) => {
      this.ListDivision = data;
    });
  }
  //============================ ngOnInit [End] ===============================================

  //============================ onEvent [Start] ===============================================
  btnClick_setfilter() {
    this.isSearchSubmitted = true;
    this.LoadData();
  }
  btnClick_unsetFilter() {
    this.txtSchDivision = "";
    this.txtSchMonthYear = "";
    this.isSearchSubmitted = false;
    this.LoadData();
  }
  //============================ onEvent [End] ===============================================

  //============================ Data Loading [Start] =========================================
  LoadData() {
    this.getTimesheetChecklist()
      .then(
        data => {
          this.modelList = data;
          this.itemTotal = (this.modelList.length != 0) ? data[0].rowTotal : 0;
        }
      ).then(() => {
        if (this.itemTotal == 0) {
          this.currentPageNumber = 0;
        }
        this.totalPages = Math.ceil(this.itemTotal / environment.PageSize)
      })
  }

  async getTimesheetChecklist(): Promise<TimeSheetChecklistInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.pagesize;

      var objectjson = {}; 

      if (this.isSearchSubmitted) objectjson['OnlyWithPending'] = 1;
      objectjson['DivisionCode'] = this.checkUndefinedString(this.txtSchDivision);
      objectjson['TimeSheetDate'] = this.checkUndefinedString(this.txtSchMonthYear);
      objectjson['rowFetch'] = this.pagesize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson)

      this.modelOnPromise = this.httpClient
        .post<TimeSheetChecklistInfo[]>(this.baseurl + "TimeSheet/GetChecklistTimesheet",
          strjson, httpOptions)
        .toPromise()

      return this.modelOnPromise;
    }
  }

  async LoadDivision() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<DivisionInfo[]>(this.baseurl + "Division/GetDivision", strjson, httpOptions)
        .toPromise()
    }
  }
   //============================ Data Loading [End] =========================================

  //============================ Misc Functions [Start] =========================================
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput;

  }
  //============================ Misc Function [End] =========================================

  //============================ Pagination [Start] =========================================
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadData();
    }
  }
  //============================ Pagination [End] =========================================
}
